import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Alert, Drawer, Empty, Input } from 'antd';
import { normalizeString } from '../../../services/util/string';
import SelectPaymentStatus, { PAYMENT_STATUS } from '../../atoms/SelectPaymentStatus';
import PayrollItemList from './PayrollItemList';

const { Search } = Input;

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FILTER_STRATEGIES = {
  [PAYMENT_STATUS.ALL]: () => true,
  [PAYMENT_STATUS.PAID]: (item) => !!item.paidDate,
  [PAYMENT_STATUS.UNPAID]: (item) => !item.paidDate,
};

export const filterCooperators = (items, { searchTerm, selectedStatus }) => {
  if (!items) {
    return [];
  }

  const normalizedSearchTerm = normalizeString(searchTerm || '');

  return items.filter((item) => {
    const cooperator = item.cooperator || {};
    const name = normalizeString(cooperator.name || '');
    const cpf = normalizeString(cooperator.cpf || '');

    const isTermMatched = name.includes(normalizedSearchTerm) || cpf.includes(normalizedSearchTerm);
    if (!isTermMatched) {
      return false;
    }

    const filterStrategy = FILTER_STRATEGIES[selectedStatus] || FILTER_STRATEGIES[PAYMENT_STATUS.ALL];
    return filterStrategy(item);
  });
};

function DrawerCooperators({ isDrawerOpen, onClose, items }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(PAYMENT_STATUS.ALL);

  if (!items) {
    return null;
  }

  const filteredItems = filterCooperators(items, { searchTerm, selectedStatus });

  return (
    <Drawer
      title="Detalhes dos Cooperados"
      closable={{ 'aria-label': 'Close Button' }}
      onClose={onClose}
      width={500}
      open={isDrawerOpen}
    >
      <DrawerContent>
        <Search
          onChange={(e) => setSearchTerm(e.target.value)}
          type="text"
          value={searchTerm}
          placeholder="Pesquisar Cooperado (Nome ou CPF)"
          allowClear
        />

        <SelectPaymentStatus
          onChange={setSelectedStatus}
          selectedStatus={selectedStatus}
        />

        <Alert
          message="Nota: Após o pagamento realizado pelo financeiro, a confirmação bancária e a disponibilização do comprovante podem levar até 1 (um) dia útil devido ao processamento do arquivo de retorno do banco."
          type="warning"
          style={{ borderRadius: 8 }}
        />

        {filteredItems.length > 0 && <PayrollItemList items={filteredItems} />}

        {filteredItems.length === 0 && <Empty description="Nenhum cooperado encontrado!" />}
      </DrawerContent>
    </Drawer>
  );
}

DrawerCooperators.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default DrawerCooperators;
